import { useTranslation } from 'react-i18next';
import TitMod from '../common/TitMod';
import styles from './Contact.module.less'

function Index({ history }) {
  const { t } = useTranslation()

  return (
    <TitMod title={t('contactUs')} modClass={styles.contact}>
      <a className={`${styles.card} ${styles.first}`} href="#a" onClick={e => e.preventDefault()}>
        <img src={`http://p0.${process.env.REACT_APP_STATIC_HOST}/t0149aee5649c6f67cd.png`} alt={t('marketCoop')}/>
        <span>{t('marketCoop')}</span>
        <em>{t('marketEmail')}</em>
      </a>
      <a className={styles.card} href="#a" onClick={e => e.preventDefault()}>
        <img src={`http://p0.${process.env.REACT_APP_STATIC_HOST}/t01d1e5bbcdb8206455.png`} alt={t('marketCoop')}/>
        <span>{t('productCoop')}</span>
        <em>{t('productEmail')}</em>
      </a>
    </TitMod>
  );
}

export default Index;
